import React from 'react';
import { ExternalLink, Heart } from 'lucide-react';

interface EmbedHeaderProps {
  isEmbedMode: boolean;
}

export default function EmbedHeader({ isEmbedMode }: EmbedHeaderProps) {
  if (!isEmbedMode) return null;

  return (
    <div className="bg-appines-dark text-white p-3 text-center">
      <div className="flex items-center justify-center gap-2 text-sm">
        <Heart className="w-4 h-4" />
        <span>Simulateur de revenus - Professionnels de santé</span>
        <a
          href={window.location.href.split('?')[0]}
          target="_blank"
          rel="noopener noreferrer"
          className="ml-2 inline-flex items-center gap-1 text-appines-secondary hover:text-white underline"
        >
          <ExternalLink className="w-3 h-3" />
          Ouvrir en plein écran
        </a>
      </div>
    </div>
  );
}